import { render, staticRenderFns } from "./TestPage.vue?vue&type=template&id=3c49a79b&scoped=true"
import script from "./TestPage.vue?vue&type=script&lang=ts"
export * from "./TestPage.vue?vue&type=script&lang=ts"
import style0 from "./TestPage.vue?vue&type=style&index=0&id=3c49a79b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c49a79b",
  null
  
)

export default component.exports